import { render, staticRenderFns } from "./FavoriteNotification.vue?vue&type=template&id=44f2b5d2"
import script from "./FavoriteNotification.vue?vue&type=script&lang=js"
export * from "./FavoriteNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports